import React from 'react'
import "./ColumnCardtxtstyle.scss"

function ColumnCardTxt() {
  return (
    <>
      <div className='cardNewstxt'>
          <h2>Yangiliklar</h2>
          <div className='display newsCategori'>
          <p>Hammasi</p>
          <p>Mahsulotlar haqida</p>
          <p>Shifokorlar tavsiya qiladilar</p>
          <p>Ozish</p>
          <p>Salomatlik</p>
          <p>Detoks</p>
          </div>
        </div>
    </>
  )
}

export default ColumnCardTxt